import { useEffect } from "react";

const Scripts = () => {

    const jqueryScript = "/js/web/onboarding/jquery.js";

    const scriptSources = [
        "/js/web/onboarding/nicepage.js",
    ];

    const loadScript = (src) => {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Error loading script: ${src}`));
            document.body.appendChild(script);
        });
    };

    useEffect(() => {

        const loadScripts = async () => {
            try {
                await loadScript(jqueryScript);
                for (const src of scriptSources) {
                    await loadScript(src);
                }
            } catch (error) {
                console.error(error);
            }
        };

        loadScripts();

        // Cleanup function to remove scripts
        return () => {
            const allScripts = [jqueryScript, ...scriptSources];
            allScripts.forEach((src) => {
                const script = document.querySelector(`script[src="${src}"]`);
                if (script) {
                    document.body.removeChild(script);
                }
            });
        };
    }, []);

    return null;
};

export default Scripts;
